import React, { useState } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import './LanguageSwitcher.css';

const languages = [
    { code: 'en', label: 'EN', fullName: 'English' },
    { code: 'ar', label: 'AR', fullName: 'العربية' },
    { code: 'ku', label: 'KU', fullName: 'کوردی' }
];

const LanguageSwitcher = () => {
    const { language, changeLanguage } = useLanguage();
    const [isOpen, setIsOpen] = useState(false);

    const currentLang = languages.find(lang => lang.code === language);

    const handleSelect = (code) => {
        changeLanguage(code);
        setIsOpen(false);
    };

    return (
        <div className="language-switcher">
            <button
                className="language-switcher__button"
                onClick={() => setIsOpen(!isOpen)}
                aria-label="Change language"
                aria-expanded={isOpen}
            >
                <span className="language-switcher__label">{currentLang.label}</span>
            </button>

            {isOpen && (
                <React.Fragment>
                    <div className="language-switcher__backdrop" onClick={() => setIsOpen(false)} />
                    <div className="language-switcher__dropdown animate-fade-in">
                        {languages.map((lang) => (
                            <button
                                key={lang.code}
                                className={`language-switcher__option ${lang.code === language ? 'language-switcher__option--active' : ''
                                    }`}
                                onClick={() => handleSelect(lang.code)}
                            >
                                <span className="language-switcher__full-name">{lang.fullName}</span>
                            </button>
                        ))}
                    </div>
                </React.Fragment>
            )}
        </div>
    );
};

export default LanguageSwitcher;
